import { render, staticRenderFns } from "./AppLayoutMainArea.vue?vue&type=template&id=ce6bf38c&scoped=true&"
import script from "./AppLayoutMainArea.vue?vue&type=script&lang=js&"
export * from "./AppLayoutMainArea.vue?vue&type=script&lang=js&"
import style0 from "./AppLayoutMainArea.vue?vue&type=style&index=0&id=ce6bf38c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce6bf38c",
  null
  
)

export default component.exports